import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { APP_CONFIG } from '../config/app-config.token';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(APP_CONFIG);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        sessionStorage.removeItem(config.auth.tokenStorageKey);
        if (config.auth.gatewayLoginUrl) {
          window.location.href = config.auth.gatewayLoginUrl;
        }
      }
      return throwError(() => error);
    }),
  );
};
